module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"project_hash":"Making a project save","download_hash":"Download project save file"},"fr":{"project_hash":"Effectuer une sauvegarde du projet","download_hash":"Télécharger la sauvegarde du projet"}}')
  delete Component.options._Ctor
}
